import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function AboutCTA() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const goToProducts = () => {
    navigate("/");
    setTimeout(() => {
      const el = document.querySelector("#products");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 400);
  };

  const goToFeatured = () => {
    navigate("/");
    setTimeout(() => {
      const el = document.querySelector("#featured");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 400);
  };

  return (
    <section className="py-28 md:py-36 bg-[#faf8f4]" ref={ref}>
      <div className="max-w-4xl mx-auto px-6 md:px-16 text-center">
        <div
          className={`transition-all duration-1000 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          <div className="flex items-center justify-center gap-3 mb-8">
            <span className="w-12 h-px bg-[#8b6f47]"></span>
            <i className="ri-sparkling-2-line text-[#8b6f47] text-xl"></i>
            <span className="w-12 h-px bg-[#8b6f47]"></span>
          </div>

          <h2
            className="text-[#2d2520] font-bold mb-6 leading-[1.4]"
            style={{
              fontSize: "clamp(1.5rem, 3vw, 2.125rem)",
              fontFamily: "'Noto Serif TC', serif",
            }}
          >
            與我們一起，找到屬於你的守護能量
          </h2>

          <p
            className="text-[#7a6a5a] leading-[1.75] mb-12 max-w-xl mx-auto"
            style={{
              fontSize: "1.1875rem",
              fontFamily: "'Noto Serif TC', serif",
            }}
          >
            了解了我們的故事與理念，現在讓我們為你找到那件與你頻率共鳴的能量飾品。
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={goToProducts}
              className="px-10 py-4 bg-[#8b6f47] text-white rounded-full text-[1rem] font-medium tracking-widest cursor-pointer hover:bg-[#7a5f3a] transition-all duration-300 whitespace-nowrap"
              style={{ fontFamily: "'Noto Serif TC', serif" }}
            >
              探索能量系列
            </button>
            <button
              onClick={goToFeatured}
              className="px-10 py-4 border-2 border-[#2d2520] text-[#2d2520] rounded-full text-[1rem] font-medium tracking-widest cursor-pointer hover:bg-[#2d2520] hover:text-white transition-all duration-300 whitespace-nowrap"
              style={{ fontFamily: "'Noto Serif TC', serif" }}
            >
              查看人氣精選
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
